<template>
  <div @drop="dropped" @dragenter="dragEnter" @dragover="dragOver" @dragleave="dragLeave" v-bind:class="classes">
      <slot></slot>
  </div>
</template>

<script>

const CLS_DRAG_HOVER='c-drop-wrap--hovered';
const CLS_DROP_WRAP = 'c-drop-wrap';

const comp = {
  name: 'DropContainer',
  data: function(){
    const classes = {};
    classes[CLS_DRAG_HOVER] = false;
    classes[CLS_DROP_WRAP] = true;
    return {classes};
  },
  computed: {
    firstChild(){
      for(const child of this.$children){
        return child;
      }
    },
    value(){
      return this.firstChild.value;
    }
  },
  methods:{
    dragOver: function(e){
        e.preventDefault();
    },
    dragEnter: function(e){
      this.dragHover()
      e.preventDefault();
    },
    dragLeave: function(e){
      this.dragNotHover()
      e.preventDefault();
    },
    dropped: function(e){
        e.preventDefault();
        const data = e.dataTransfer.getData('application/json');
        const transfer = JSON.parse(data);
        const {value, label} = transfer;
        const args = {from: value, to: this.value, label};
        this.$emit('dragged', args);
    },
    dragHover(){
      console.log('hovering');
      this.$set(this.classes,CLS_DRAG_HOVER,true);
    },
    dragNotHover(){
      console.log('not hovering');
      this.$set(this.classes,CLS_DRAG_HOVER,false);
    }
  }
};
export default comp;
</script>

<style lang="less" >
    .c-drop-wrap {
        height: 100%;
    }

</style>